// normalizers
import parseCommentData from "./parseCommentData";

const parseCommentListData = ({ rawResponseData }) => {
  return rawResponseData.map((item) =>
    parseCommentData({ rawResponseData: item })
  );
};

export default parseCommentListData;
